



































































import Vue from 'vue';
import {
  defineComponent,
  ref,
  computed,
  ComputedRef,
  getCurrentInstance,
  ComponentInternalInstance,
  watch,
} from '@vue/composition-api';
import TeamTree from '@/renderer/components/TeamTree/index.vue';
import loginWithPhoneHandler from '@/renderer/components/login/compositions/loginWithPhoneHandler';
import sidebarGuideHandler from '@/renderer/views/desktop/BaseSidebar/SidebarGuideHandler';
import i18n, { i18n_t } from '@/locales/i18n';
import { SMH } from '@/renderer/scripts/smh';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import storage from '@/renderer/scripts/utils/storage';
import user from '@/renderer/scripts/utils/user';
import ipc from '@/renderer/scripts/utils/ipc';
import { isAdminOrSuperAdmin } from '@/renderer/scripts/utils/UserRole/getters';
import { FILE_MANAGE_ROUTE_LIST } from '@/renderer/scripts/utils/ConstantConfig';
type TeamPathInfo = {
  path: string[];
  spaceId: string;
  id: number;
  orgId: number;
};
const teamTreeHandler = (vm: Vue) => {
  const isOpenTeamTree = ref(storage.get(storage.StoreKey.OPEN_TEAM_TREE_IN_SIDEBAR) || true);
  const defaultTeamPath = ref<string[] | boolean>(false);

  const teamTreeDefaultHeight = ref(270);
  const teamTreeCurrentHeight = ref(0);
  const canResizeTeamTree = ref(true);

  const methods = {
    switchTree() {
      isOpenTeamTree.value = !isOpenTeamTree.value;
      // 重新展开企业空间树时重新加载一次企业空间列表 应对pc端不能重新获取列表
      if (isOpenTeamTree.value) {
        const { teamTree } = vm.$refs;
        if (Array.isArray(teamTree)) {
          (teamTree as any)[0].initData();
        }
      }
      storage.set(storage.StoreKey.OPEN_TEAM_TREE_IN_SIDEBAR, isOpenTeamTree.value);
    },
    initData(refresh?: boolean) {
      // 切换身份后这里只会恢复当前企业的teamPath
      const teamPathInfo = storage.get(storage.StoreKey.TEAM_PATH) as TeamPathStorageInfo;
      const { query } = vm.$route;
      const { teamPath } = query;
      if (teamPathInfo || teamPath) {
        const { path, orgId } = teamPathInfo;
        if (orgId && vm.$store.getters.orgId !== -1 && vm.$store.getters.orgId !== orgId) {
          // 刷新的时候orgId为-1，但不应该走这，要保留团队路径
          defaultTeamPath.value = true;
          return;
        }
        const newPath = teamPath ? (teamPath as string).split('/') : path; // 避免强制刷新，，应该优先采用路由
        defaultTeamPath.value = newPath;
      } else {
        defaultTeamPath.value = true;
      }
      if (refresh) {
        const { teamTree } = vm.$refs;
        if (Array.isArray(teamTree)) {
          (teamTree as any)[0].initData(true);
        }
      }
    },
    changeTeamWithDirPath(dirPath = '') {
      const teamPathInfo = storage.get(storage.StoreKey.TEAM_PATH) as TeamPathStorageInfo;
      const { query: routerQuery } = vm.$route;
      // 如果路由携带了teamPath参数, 表示存在目标路径，无需读取本地存储路径跳转
      if (Object.keys(routerQuery).length) return;
      if (teamPathInfo && teamPathInfo.path) {
        const { path, orgId } = teamPathInfo;
        if (orgId && vm.$store.getters.orgId !== orgId) {
          defaultTeamPath.value = true;
          const { teamTree } = vm.$refs;
          if (Array.isArray(teamTree)) {
            (teamTree as any)[0].nodeActiveByPath();
          }
          return;
        }
        const { teamTree } = vm.$refs;
        if (Array.isArray(teamTree)) {
          (teamTree as any)[0].nodeActiveByPath(path, {
            noEmit: true,
          });
        }
        const query = {
          teamPath: [...(teamPathInfo.path || [])].join('/'),
          spaceId: teamPathInfo.spaceId,
          teamId: `${teamPathInfo.id}`,
          path: dirPath,
        };
        dispatchRouter({
          name: 'teamSpace',
          query,
        });
      } else {
        const { teamTree } = vm.$refs;
        if (Array.isArray(teamTree)) {
          (teamTree as any)[0].nodeActiveByPath();
        }
      }
    },
    async onChangeTeam(node: { data: SMH.TeamTreeNode; init: boolean }) {
      if (!node) return;
      if (node.init) return;
      // const teamTreeNode = node.data;
      // const tokenItem = await accessTokenManager.get(teamTreeNode.spaceId);
      const selectedTeam = node.data;
      const query = {
        teamPath: [...(selectedTeam.path || [])].join('/'),
        spaceId: selectedTeam.spaceId,
        teamId: `${selectedTeam.id}`,
      };
      const { query: currRouteQuery, name: currRouteName } = vm.$route;
      if (currRouteQuery.teamPath === query.teamPath && currRouteQuery.spaceId === query.spaceId) return;
      const type = currRouteName === 'teamSpace' ? 'replace' : 'push';
      dispatchRouter(
        {
          name: 'teamSpace',
          query,
        },
        type,
      );
      // 切换团队时需要保存当前团队路径，以便刷新或切换路由时仍能回到上次进入的团队
      // 这里记录的teamPath需要和企业绑定
      storage.set(storage.StoreKey.TEAM_PATH, {
        path: [...(selectedTeam.path || [])],
        spaceId: selectedTeam.spaceId,
        id: selectedTeam.id,
        orgId: vm.$store.getters.orgId,
      });
    },
    onHeightChange(height: number) {
      if (height > teamTreeDefaultHeight.value) {
        canResizeTeamTree.value = true;
        teamTreeCurrentHeight.value = teamTreeDefaultHeight.value;
      } else {
        canResizeTeamTree.value = false;
        teamTreeCurrentHeight.value = height;
      }
    },
  };
  return {
    isOpenTeamTree,
    defaultTeamPath,
    methods,
    teamTreeDefaultHeight,
    canResizeTeamTree,
    teamTreeCurrentHeight,
  };
};
export default defineComponent({
  name: 'SidebarMenu',
  components: {
    TeamTree,
  },
  setup() {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const showPersonalSpace = computed(() => vm.$store.getters.hasPersonalSpace);
    // const { transmissionNum } = handleTransmissionNum();
    const {
      isOpenTeamTree,
      defaultTeamPath,
      methods: teamTreeMethods,
      teamTreeDefaultHeight,
      teamTreeCurrentHeight,
      canResizeTeamTree,
    } = teamTreeHandler(vm);
    const editionFlag = computed(() => vm.$store.getters.editionFlag);
    const isTemporary = computed(() => vm.$store.getters.userBaseInfo.isTemporary);
    const userExist = computed(() => {
      const { userId } = vm.$store.getters.userBaseInfo;
      return userId !== -1;
    });
    const menuMap = computed<Record<string, Record<string, RouteMenu>>>(() => ({
      baseMenu: {
        workbench: {
          routeList: [
            {
              title: i18n_t('我的工作台'),
              route: 'workbench',
              icon: 'menu-workbench',
            },
          ],
        },
        storage: {
          title: i18n_t('存储空间'),
          routeList: [
            {
              title: i18n_t('企业空间'),
              route: 'teamSpace',
              icon: 'menu-team-space',
              isHidden: editionFlag.value === 'personal' || isTemporary.value || !userExist.value,
            },
            {
              title: i18n_t('协作空间'),
              route: 'collaborationSpace',
              icon: 'menu-collaboration-space',
            },
            {
              title: i18n_t('个人空间'),
              route: 'personalSpace',
              icon: 'menu-personal-space',
              isHidden: !vm.$store.getters.hasPersonalSpace || vm.$store.getters.userBaseInfo.isTemporary,
            },
          ],
        },
        fileManage: {
          title: i18n_t('文件管理'),
          routeList: [
            {
              title: i18n_t('与我相关'),
              route: 'relatedToMe',
              icon: 'menu-share-manage',
            },
            {
              title: i18n_t('安全外链'),
              route: 'linkManage',
              icon: 'menu-link-manage',
            },
            {
              title: i18n_t('误删恢复'),
              route: 'recycleBin',
              icon: 'menu-recycle-bin',
            },
            {
              title: i18n_t('可疑文件'),
              route: 'suspiciousFile',
              icon: 'menu-suspicious-file',
              // 开启敏感词或查毒时才展示菜单
              isHidden:
                editionFlag.value !== 'enterprise' ||
                (!vm.$store.getters.enableSensitiveWord && !vm.$store.getters.enableManageAntivirus),
            },
            {
              title: i18n_t('同步备份'),
              route: 'fileSync',
              icon: 'menu-sync-manage',
              isHidden: vm.$store.getters.isBrowser || editionFlag.value !== 'enterprise',
            },
          ],
        },
      },
      adminMenu: {
        statistics: {
          id: 'advanceGuide-step-3',
          title: i18n_t('数据报表'),
          isHidden: !isAdminOrSuperAdmin.value,
          routeList: [
            {
              title: i18n_t('空间统计'),
              route: 'spaceStatistics',
              icon: 'menu-space-statistics',
              isOpen: false,
            },
            {
              title: i18n_t('用户统计'),
              route: 'userStatistics',
              icon: 'menu-user-statistics',
            },
            {
              title: i18n_t('流量统计'),
              route: 'trafficStatistics',
              isHidden: editionFlag.value !== 'enterprise' || vm.$store.getters.isPrivate,
              icon: 'menu-traffic-statistics',
            },
          ],
        },

        management: {
          id: 'advanceGuide-step-1',
          title: i18n_t('用户与团队管理'),
          routeList: [
            {
              title: i18n_t('用户管理'),
              route: 'userManagement',
              icon: 'menu-user-management',
              isHidden: !isAdminOrSuperAdmin.value,
            },
            {
              title: i18n_t('团队管理'),
              route: 'teamManagement',
              icon: 'menu-team-management',
            },
            {
              title: i18n_t('初始化设置'),
              route: 'initializeSettings',
              icon: 'menu-initialize-settings',
              isHidden: !isAdminOrSuperAdmin.value,
            },
          ],
        },
        orgmanagement: {
          id: 'advanceGuide-step-2',
          title: i18n_t('网盘配置'),
          isHidden: !isAdminOrSuperAdmin.value,
          routeList: [
            {
              title: i18n_t('界面定制'),
              route: 'uiDesign',
              icon: 'menu-ui-design',
            },
            {
              title: i18n_t('账号关联'),
              route: 'accountAssociation',
              icon: 'menu-account-association',
            },
            {
              title: i18n_t('域名管理'),
              route: 'customDomain',
              icon: 'menu-custom-domain',
              isHidden: editionFlag.value !== 'enterprise',
            },
            {
              title: i18n_t('水印设置'),
              route: 'watermark',
              isHidden: !vm.$store.getters.enableManageWatermark,
              icon: 'menu-watermark',
            },
            {
              title: i18n_t('安全外链'),
              route: 'consoleLinkManagement',
              icon: 'menu-console-link-management',
            },
            {
              title: i18n_t('历史版本设置'),
              route: 'versionManagement',
              icon: 'menu-version-management',
            },
            {
              title: i18n_t('安全扫描'),
              route: 'securityScan',
              isHidden: !vm.$store.getters.enableSensitiveWord && !vm.$store.getters.enableManageAntivirus,
              icon: 'menu-security-scan',
            },
          ],
        },

        logQuery: {
          routeList: [
            {
              title: i18n_t('日志查询'),
              route: 'logQuery',
              icon: 'menu-log-query',
            },
          ],
        },
      },
    }));

    /**
     * @description 菜单激活值
     */
    const menuValue = computed(() => vm.$route.meta?.routerParent || vm.$route.name || '');
    const isShowBaseMenu: ComputedRef<boolean> = computed(() => FILE_MANAGE_ROUTE_LIST.includes(menuValue.value));
    const { getIndexPage } = loginWithPhoneHandler();

    // 是否在新手引导中,若在新手引导中，则不允许点击菜单，直至引导结束。
    const { inGuide } = sidebarGuideHandler();
    /**
     * sideBarMenu 中的路由前置处理器
     * 1. 新手引导模式下，禁止跳转
     * 2. 切换企业空间菜单时，禁止跳转
     * 3. 点击自己时，禁止跳转
     */
    const beforeRouterChange = async (item: RouteItem, e?: MouseEvent): Promise<Boolean> => {
      // 新手引导模式不跳转
      if (inGuide.value === true) return false;
      // 如果点击的是企业空间的展开收起，不作处理
      if ((e?.target as HTMLElement)?.className?.includes('chevron')) return false;
      if (item.route === menuValue.value) return false;
      return true;
    };
    /**
     * 路由跳转
     * @param item
     * @param e
     */
    const handleRouteChange = async (item: RouteItem, e?: MouseEvent) => {
      // 走一遍路由前置处理器
      const flag = await beforeRouterChange(item, e);
      // 若前置路由不通过，不再继续
      if (!flag) return;

      // 返回首页
      const goHome = async () => {
        const routerName = getIndexPage(); // 动态获取首页
        await dispatchRouter({
          name: routerName,
        });
      };
      // 清理团队选择树的状态
      const clearTeamTreeDOM = () => {
        const { teamTree } = vm.$refs;
        Array.isArray(teamTree) && teamTree.length > 0 && (teamTree as any)[0].clearActiveNode();
      };
      switch (item.route) {
        case 'return':
          await goHome();
          ipc.emit(ipc.RENDERER_EVENTS_MAP.STOP_GUIDE);
          break;
        case 'teamSpace':
          await dispatchRouter({
            name: item.route,
            query: item.query,
          });
          teamTreeMethods.changeTeamWithDirPath(item.query?.path);
          // TODO: 目前tdesign更新tree的data会整个重新渲染，导致树会有动态刷新效果且出现一个中间态：列表为空。需要找tdesign提issue。
          // teamTreeMethods.initData(true);
          break;
        default:
          // 切其他空间需要清除树组件激活态
          if (isShowBaseMenu.value && isOpenTeamTree.value) {
            clearTeamTreeDOM();
          }
          await dispatchRouter({
            name: item.route,
            query: item.query,
          });
      }
    };
    const handleMenuActive = (item: { route: string }) => {
      if (item.route === vm.$route.name) {
        return true;
      }
      if (
        item.route === 'collaborationSpace' &&
        ['collaborationSpaceList', 'collaborationShareList'].includes(vm.$route.name ?? '')
      ) {
        return true;
      }
      if (item.route === 'workbench' && vm.$route.name === 'favoriteList') {
        return true;
      }
      if (item.route === 'relatedToMe' && ['relatedToMeFileList', 'fileApply'].includes(vm.$route.name ?? '')) {
        return true;
      }
      return false;
    };
    if (vm.$route.name === 'teamSpace') {
      teamTreeMethods.initData();
    }

    // 切换企业后重新获取企业空间列表
    user.on('switch-org-finished', () => {
      const { teamTree } = vm.$refs;
      defaultTeamPath.value = false;
      Array.isArray(teamTree) && teamTree.length > 0 && (teamTree as any)[0].initData();
    });

    watch(
      () => vm.$route.name,
      val => {
        // 企业空间的路由改变比较特殊，有一些逻辑处理。
        if (val === 'teamSpace') {
          teamTreeMethods.changeTeamWithDirPath();
        } else {
          // 公共的路由改变
          handleRouteChange({ route: val as string });
        }
      },
    );
    return {
      showPersonalSpace,
      menuMap,
      menuValue,
      isShowBaseMenu,
      isAdminOrSuperAdmin,
      handleRouteChange,
      handleMenuActive,
      editionFlag,
      inGuide,
      isOpenTeamTree,
      defaultTeamPath,
      teamTreeMethods,
      isTemporary,
      userExist,
      teamTreeDefaultHeight,
      teamTreeCurrentHeight,
      canResizeTeamTree,
    };
  },
});
